<template>
  <div class="h5-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar
        class="top-bar"
        title="权益中心"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>

    <!-- 标签页容器：优化移动端滑动体验 -->
    <div class="container-item">
      <van-tabs
          v-model="activeTab"
          swipeable
          sticky
          ellipsis
          title-active-color="#B8860B"
          title-inactive-color="#FFFFFF"
      line-color="#B8860B"
      class="rights-tabs"
      >
      <van-tab v-for="item in equitiesList" :title="item.equitiesName" :key="item.equitiesId">
        <!-- 卡片内容：循环渲染权益卡片 -->
        <div class="tab-content">
          <van-card
              v-for="(child,inx) in item.children"
              :key="inx"
              class="rights-card"
          >
            <!-- 标题插槽：优化badge定位 -->
            <template #title>
              <div class="custom-title">
                <span class="badge">{{item.equitiesName}}券</span>
              </div>
            </template>
            <!-- 描述插槽：修复h3不显示问题 -->
            <template #desc>
              <div class="custom-desc">
                <h3>{{child.brandName}}</h3>
                <h3>{{child.seriesName || '暂无系列名称'}}</h3>
                <van-button size="small" type="primary" style="color: #fff;float: right" @click="handleUseRight(child.seriesId,item.equitiesId)">
                  立即使用
                </van-button>
              </div>
            </template>
            <template #footer>
              <p style="color: #1A1A1A;text-align: left">权益摘要：{{item.equityDesc}}</p>
            </template>
          </van-card>
        </div>
      </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {memberEquities} from "@/api/mine";
import {Dialog, Toast} from "vant"; // 补充Toast引入（避免调用时报错）
export default {
  data() {
    return {
      activeTab: 0, // 默认选中第一个标签页
      equitiesList: [], //会员权益页签数据
    };
  },
  created() {
    this.memberEquities();
  },
  methods: {
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 权益使用/领取
    handleUseRight(seriesId,type) {
      this.$router.push({path:'/benefits_use',query:{seriesId:seriesId,type:type}});
    },
    //获取会员权益
    async memberEquities(){
      try {
        const res = await memberEquities();
        if (res.code === 200 && res.data) {
          this.equitiesList = res.data.equities || [];
          console.log(102, this.equitiesList);
        } else {
          Dialog.alert({ title: "提示", message: res.returnMsg || "获取权益数据失败" });
        }
      } catch (err) {
        console.error("获取会员权益失败：", err);
        Dialog.alert({ title: "错误", message: "网络异常，请稍后重试" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
// 全局容器：适配移动端viewport
.h5-container {
  min-height: 100vh;
  background-color: #1A1A1A;
  padding: 0 16px;
  box-sizing: border-box;
}

// 标签栏样式：增强优先级
::v-deep .van-tabs .van-tabs__nav {
  background-color: #1A1A1A !important;
}
::v-deep .van-tab__text{
  color: #FFFFFF !important;
}
::v-deep .van-tab--active .van-tab__text{
  color: #B8860B !important;
}

// 核心：强制卡片背景为白色，取消默认内边距限制
::v-deep .van-card {
  background: #FFFFFF !important;
  border: none !important;
  padding: 15px !important; // 增加内边距，避免内容被遮挡
}

// 顶部导航栏：优化渐变和适配
.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  margin: 0 -16px;
  height: 46px;
  line-height: 46px;

  ::v-deep .van-nav-bar__title {
    color: #0f0f0f;
    font-weight: bold;
    font-size: 16px;
  }

  ::v-deep .van-icon-arrow-left,
  ::v-deep .van-nav-bar__text {
    color: #0f0f0f !important;
    font-size: 14px;
  }

  ::v-deep .van-nav-bar__content {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}

// 标签页容器：优化间距和背景
.container-item {
  padding: 10px 0;

  ::v-deep .rights-tabs {
    .van-tabs__wrap {
      background-color: #1A1A1A !important;
      padding-top: 5px;
    }

    .van-tab {
      font-size: 14px;
    }

    .van-tabs__content {
      padding: 10px 0;
      background-color: #1A1A1A;
    }
  }
}

// 标签页内容区域：增加卡片间距
.tab-content {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 12px; // 卡片之间的垂直间距
}

// 权益卡片样式
.rights-card {
  background-color: #fff !important;
  border-radius: 8px;
  overflow: hidden;

  // 修复标题插槽样式
  ::v-deep .van-card__title {
    padding: 0 !important;
    margin-bottom: 10px !important; // 标题和描述的间距
    font-size: 15px;
    color: #333;
    font-weight: 500;
    line-height: 1.5;
  }

  // 核心：修复描述插槽样式（解决h3不显示）
  ::v-deep .van-card__desc {
    padding: 0 !important;
    margin: 0 !important;
    font-size: inherit !important; // 取消默认字体大小限制
    color: inherit !important; // 取消默认文字颜色限制
    line-height: 1.5 !important;
    overflow: visible !important; // 取消溢出隐藏
  }

  ::v-deep .van-card__footer {
    justify-content: flex-end;
    padding: 10px 0 0 0 !important; // 调整底部内边距
    border-top: 1px solid #eee;
    margin-top: 10px;
  }
}

// 自定义标题样式：修复badge定位
.custom-title {
  position: relative;
  min-height: 20px; // 防止badge超出容器
  padding-left: 60px; // 给badge留出位置，避免重叠
}

.badge {
  position: absolute;
  left: 0;
  top: 0;
  background-color: red;
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 1.2;
}

// 自定义描述样式：确保h3显示
.custom-desc {
  h3 {
    margin: 0 ;
    padding-top: 10px;
    font-size: 14px; // 明确字体大小
    color: #333 ; // 明确文字颜色
    font-weight: 600 ;
    line-height: 1.4;
  }
  p{
    padding-top: 10px;
    font-size: 12px; // 明确字体大小
    color: #525252; // 明确文字颜色
  }
}

// 通用间距类
.mt-10 {
  margin-top: 10px;
}
</style>